// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutPageContainer {
  align-items: center;
  text-align: center;
}

.aboutContentContainer {
  display:flex;
  margin: auto;
  justify-content: center;
  width: 90vw;
  font-size: 18pt;
}

.aboutContentSubcontainer {
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 40%
}

.aboutContentImageContainer {
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 40%;
  background-color: tomato;
  border-radius: 25px;
}`, "",{"version":3,"sources":["webpack://./src/pages/AboutUs.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ;AACF;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,wBAAwB;EACxB,mBAAmB;AACrB","sourcesContent":[".aboutPageContainer {\n  align-items: center;\n  text-align: center;\n}\n\n.aboutContentContainer {\n  display:flex;\n  margin: auto;\n  justify-content: center;\n  width: 90vw;\n  font-size: 18pt;\n}\n\n.aboutContentSubcontainer {\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  width: 40%\n}\n\n.aboutContentImageContainer {\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  width: 40%;\n  background-color: tomato;\n  border-radius: 25px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
